import type { WCmsPageView } from '@zola/svc-web-api-ts-client';
import React from 'react';
import { useSelector } from 'react-redux';
import { getUserContext } from 'selectors/user/userSelectors';
import type { RouteComponentProps } from 'react-router';
import experimentFlags, { EDIT_PAGE_FORM } from '../../../../../../util/experimentFlags';

import EditPageFormV2WithRouter from './EditPageFormV2';
import EditPageFormWithRouter from './EditPageForm/EditPageForm';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface EditPageFormContainerProps extends RouteComponentProps<any, any> {
  page: WCmsPageView;
  valid: boolean;
}

const EditPageFormContainer: React.FC<EditPageFormContainerProps> = props => {
  const userContext = useSelector(state => getUserContext(state));
  const editPageFormFlag = experimentFlags.getFlag(EDIT_PAGE_FORM, userContext);

  // render new implementation when NOT_IN_TEST so can write integration tests against stage
  return editPageFormFlag ? (
    <EditPageFormWithRouter {...props} />
  ) : (
    <EditPageFormV2WithRouter {...props} />
  );
};

export default EditPageFormContainer;
